import React from "react";
import { withRedux, isLoading } from "helpers";
import { Button } from "appStyles";
import { cloneDeep } from "lodash";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";
import { AcceptInvitationForm, HasPermission } from "components";
import {
  Grid,
  Modal,
  GridItem,
  Container,
  FlexColumn,
  FlexRow,
  Image,
} from "appStyles";
import ReactGA from "react-ga";
import styled, { css } from "react-emotion";
ReactGA.initialize(
  process.env.NODE_ENV === "prod" ? "UA-108363979-2" : "UA-108363979-3"
);
import AddCircleIcon from "@material-ui/icons/AddCircle";

export const tableRowClickable = css`
  &:hover {
    background-color: rgba(137, 210, 211, 0.3);
    cursor: pointer;
  }
`;
const row = css`
  display: flex;
  flex-flow: row wrap;
  flex: 0 1 auto;
  padding: 5px 0px;
  margin-bottom: 35px;
`;

const ButtonStyle = css`
  font-weight: bold;
  font-size: 15px;
  text-decoration: none;
  background-color: #89d2d3;
  color: white;
  padding: 10px;
  width: 265px;
  line-height: 29px;
  text-align: center;
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  text-transform: none;
  font-style: normal;
  font-stretch: normal;
  border-radius: 5.5px;
  user-select: none;
  cursor: pointer;
  display: flex; /*CSS3*/
  align-items: center; /*Vertical align*/
  justify-content: center; /*horizontal align*/
`;
const col = css`
  flex: 0 0 92%;
  margin: auto 4%;
  @media only screen and (min-width: 480px) {
    margin-left: 4%;
    margin-right: 0%;
    text-align: center;
  }
`;

const col1 = css`
  @media only screen and (min-width: 768px) {
    text-align: center;
  }
  @media only screen and (min-width: 300px) {
    text-align: center;
  }
`;

const H1 = styled("h1")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 25px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
`;

const P = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 0.9375rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  display: block;
`;

class Lobby extends React.Component {
  state = {
    deleteConfirmationId: null,
    isLoadingApps: true,
  };

  componentDidMount() {
    this.props.actions.isDeleting(false);
    this.props.actions.resetBusiness();
    this.props.actions.resetApplication();
    isLoading(true);
    this.props.actions
      .getApplicationsByUserId(this.props.platformInfo.status.user.id)
      .then(() => {
        this.setState({ isLoadingApps: false });
      })
      .then(() => isLoading(false));
    // console.dir(this.props.history);
    const search = this.props.history.location.search;
    // console.log(new URLSearchParams(search).get("state"));
    // console.log(new URLSearchParams(search).get("code"));
  }

  signalDeletionConfirmation = (id) => {
    this.setState({ deleteConfirmationId: id });
  };

  deleteApplication = (appId) => {
    const { deleteConfirmationId } = this.state;

    if (!deleteConfirmationId || deleteConfirmationId !== appId) {
      this.signalDeletionConfirmation(appId);
    } else {
      this.props.actions.deleteApp(appId);
      this.signalDeletionConfirmation(null);
    }
  };

  loadApp = (appId) => () => {
    const app = this.props.appLibrary.applications[appId];
    this.props.actions.setApplication(cloneDeep(app));
    this.props.actions.setBusiness(cloneDeep(app.business));
    this.props.history.push("/application");
  };

  renderDeletionConfirmationModal = (currentDeleteApp) => {
    if (!currentDeleteApp) return null;
    const { id, name } = currentDeleteApp;

    return (
      <Modal hidden={true} padding="1em">
        <FlexColumn>
          <P fontSize="1em">Are you sure you want to delete "{name}"?</P>
          <FlexRow margin="1em 0 0 0">
            <Button onClick={() => this.signalDeletionConfirmation(null)}>
              Cancel
            </Button>
            <Button
              background="#FF5353"
              onClick={() => this.deleteApplication(id)}
            >
              Delete Application
            </Button>
          </FlexRow>
        </FlexColumn>
      </Modal>
    );
  };

  render() {
    const { appLibrary } = this.props;
    const applications = appLibrary.applications;
    if (this.state.isLoadingApps) {
      return null;
    }

    return (
      <Container>
        <AcceptInvitationForm history={this.props.history} />
        <div className={row}>
          {/*Stay Connected*/}
          <div className={col + " " + col1}>
            <div
              className={row}
              style={{ justifyContent: "space-between", alignItems: "center" }}
            >
              <H1 style={{ textAlign: "left" }}>My Applications</H1>{" "}
              <a
                onClick={() => {
                  ReactGA.pageview(`${window.location.pathname}`);
                }}
                className={ButtonStyle}
                href="/form/business"
              >
                <AddCircleIcon style={{ marginRight: "5px" }}></AddCircleIcon>
                Create New Application
              </a>
            </div>

            {/* {this.renderDeletionConfirmationModal(currentDeleteApp)}           */}

            <Table style={{ borderCollapse: "collapse", marginTop: "50px" }}>
              {/* <TableContent
                style={{
                  margin: "auto",
                  width: "100%",
                  borderCollapse: "collapse",
                  borderSpacing: "2px",
                  marginTop: "50px",
                }}
              > */}
              <TableHead>
                <TableRow
                  style={{
                    textAlign: "left",
                    borderBottom: "1pt solid black",
                    backgroundColor: "#89d2d3",
                    color: "white",
                  }}
                >
                  <TableCell style={{ width: "75%" }}>
                    <P
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: "white",
                        margin: "0px",
                      }}
                    >
                      Name
                    </P>
                  </TableCell>
                  <TableCell>
                    <P
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: "white",
                        margin: "0px",
                      }}
                    >
                      Last Modified
                    </P>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(applications).map((idx) => {
                  const app = applications[idx];
                  const { id, name, modifiedDate } = app;
                  const date = new Date(modifiedDate).toLocaleDateString(
                    "en-US"
                  );
                  return (
                    <HasPermission
                      appId={id}
                      key={idx}
                      requiredPermissions={[0, 1, 2, 3]}
                    >
                      <TableRow
                        onClick={this.loadApp(id)}
                        style={{
                          textAlign: "left",
                          borderBottom: "1px solid #DADADA",
                        }}
                        className={tableRowClickable}
                      >
                        <TableCell style={{ padding: "15px 10px" }}>
                          <P>{name}</P>
                        </TableCell>
                        <TableCell>
                          <P>{modifiedDate ? date : "----"}</P>
                        </TableCell>
                      </TableRow>
                    </HasPermission>
                  );
                })}
              </TableBody>
              {/* </TableContent> */}
            </Table>
          </div>
        </div>

        {/* TODO: make this into a button */}
        {/* <Button
          style={{
            backgroundColor: "#89d2d3"
          }}
          onClick={() => {
            ReactGA.pageview(`${window.location.pathname}`);
          }}
        > */}

        {/* </Button> */}
      </Container>
    );
  }
}

export default withRedux(Lobby);
